import { Button as ButtonProps } from 'types/button'
import Spinner from '../spinner'

/**
 * Common component for button
 */
const Button = ({
  buttonText,
  textClassName = '',
  className = '',
  type = 'submit',
  size = 'medium',
  theme = 'primary',
  variant = 'filled',
  loading = false,
  disabled = false,
  icon = null,
  iconPosition = 'start',
  iconClassName = '',
  icon2,
  icon2ClassName,
  ...props
}: ButtonProps) => {
  const commonClasses = `inline-flex ${
    iconPosition === 'end' ? 'flex-row-reverse' : ''
  } justify-center gap-2 items-center transition-all duration-300 outline-none focus:outline-none antialiased ${
    variant === 'custom' ? '' : 'border-2 rounded-md font-bold capitalize'
  }`

  const disableClasses = {
    filled: 'disabled:bg-gray-400 disabled:text-white disabled:border-gray-400',
    outline:
      'disabled:border-gray-400 disabled:text-gray-400 disabled:bg-white',
  }

  const colors = {
    primary: {
      filled: `bg-button-primary border-transparent text-white ${
        loading
          ? ''
          : `hover:text-button-primary hover:border-button-primary hover:bg-button-secondary ${disableClasses.filled}`
      }`,
      outline: `text-button-primary border-button-primary bg-button-secondary ${
        loading
          ? ''
          : `hover:bg-button-primary hover:text-button-secondary ${disableClasses.outline}`
      }`,
    },
    success: {
      filled: `bg-green-light border-transparent text-green-darker ${
        loading ? '' : `hover:bg-green-dark ${disableClasses.filled}`
      }`,
      outline: `text-green-darker border-green-darker bg-white ${
        loading
          ? ''
          : `hover:bg-green-light hover:border-transparent hover:text-green-darker ${disableClasses.outline}`
      }`,
    },
  }

  const sizeClasses = {
    small: 'px-1.5 py-1 text-xs',
    medium: 'px-2 py-1.5 text-sm',
    large: 'px-4 py-1.5 text-lg',
  }

  const buttonClasses = `${className} ${commonClasses} ${
    variant === 'custom' ? '' : `${colors[theme][variant]} ${sizeClasses[size]}`
  }`

  return (
    <button
      type={type}
      className={buttonClasses}
      disabled={loading || disabled}
      {...props}
    >
      {loading ? (
        <Spinner size={size} />
      ) : (
        <>
          {icon && (
            <span
              className={`inline-flex h-4 w-4 shrink-0 items-center justify-center ${iconClassName}`}
            >
              {icon}
            </span>
          )}

          {buttonText && (
            <span className={`truncate whitespace-nowrap ${textClassName}`}>
              {buttonText}
            </span>
          )}
          {icon2 && (
            <span
              className={`inline-flex h-4 w-4 shrink-0 items-center justify-center ${icon2ClassName}`}
            >
              {icon2}
            </span>
          )}
        </>
      )}
    </button>
  )
}

export default Button
